<form #form="ngForm" class="form form-full-width">
    <div class="table-container">
        <table>
            <thead>
                <tr>
                    <th colspan="3">
                        Posting scores for:
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let p of playersToPost; let i = index">
                    <td style="width: 50%;">{{ p.player.firstName }} {{ p.player.lastName }}</td>
                    <td>
                        <div class="field">
                            <input
                                type="text"
                                name="score{{ i }}"
                                required
                                [(ngModel)]="p.score"
                                #scoreModel="ngModel"
                                placeholder=" "
                            />
                            <label></label>
                            <span class="error" *ngIf="scoreModel.invalid && scoreModel.touched">
                                Score is required
                            </span>
                        </div>
                    </td>
                    <td class="center">
                        <img src="../../../../../assets/noun-x-circle-4815624-FF001C.png" width="25px" (click)="removePlayer(p.player.playerId)" />
                    </td>
                </tr>
                <tr>
                    <td colspan="3">
                        <button (click)="postScore()">Post</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</form>

<div class="table-container margin-top-medium">
    <table>
        <thead>
            <tr>
                <th colspan="2">
                    Select others to post for:
                </th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let p of selectablePlayers">
                <tr *ngIf="!p.isSelected">
                    <td>{{ p.obj.firstName }} {{ p.obj.lastName }}</td>
                    <td>
                        <button (click)="addPlayerToPostList(p.obj.playerId)">
                        Select
                        </button>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>




